/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit'
import { BIG_ZERO } from 'utils/bigNumber'
import { WheelState } from 'state/types'
import { fetchWheelUserData, fetchWheelUserPurchasedNumbers } from './fetchWheelUser'
import fetchWheelPublicData from './fetchWheel'

const initialState: WheelState = {
  data: {
    maxBuyTicket: 0,
    endTime: 0,
    isOpened: false,
    lastWinners: [],
    prizePoolBalance: BIG_ZERO,
    userData: { pendingReward: BIG_ZERO },
  },
  userDataLoaded: false,
}

// Thunks
export const fetchWheelPublicDataAsync = () => async (dispatch) => {
  const data = await fetchWheelPublicData()

  dispatch(setWheelPublicData(data))
}

export const fetchWheelUserDataAsync =
  (account: string): any =>
  async (dispatch) => {
    let userData = {}
    let purchasedNumbers = []
    const setUserData = async () => {
      userData = await fetchWheelUserData(account)
    }
    const setPurchasedNumbers = async () => {
      purchasedNumbers = await fetchWheelUserPurchasedNumbers(account)
    }
    await Promise.all([setUserData(), setPurchasedNumbers()])

    dispatch(setWheelUserData({ ...userData, purchasedNumbers }))
  }

export const WheelSlice = createSlice({
  name: 'Wheel',
  initialState,
  reducers: {
    setWheelPublicData: (state, action) => {
      const publicData = action.payload
      state.data = {
        ...state.data,
        ...publicData,
      }
    },
    setWheelUserData: (state, action) => {
      const userData = action.payload
      state.data = {
        ...state.data,
        userData,
      }
      state.userDataLoaded = true
    },
    updateWheelUserData: (state, action) => {
      const userData = action.payload
      state.data = {
        ...state.data,
        userData: {
          ...state.data.userData,
          ...userData,
        },
      }
    },
  },
})

// Actions
export const { setWheelPublicData, setWheelUserData, updateWheelUserData } = WheelSlice.actions

export default WheelSlice.reducer
